// extracted by mini-css-extract-plugin
module.exports = {"LoadingIndicator":"document-repository__LoadingIndicator__LoadingIndicator"};